import { render } from "./LegacyActions.vue?vue&type=template&id=170d3a7d"
import script from "./LegacyActions.vue?vue&type=script&lang=js"
export * from "./LegacyActions.vue?vue&type=script&lang=js"
script.render = render

export default script